(function($){
    'use strict';

    $('.js-banner-carousel').each(function() {
    	var $carousel = $(this);

	    $carousel .on('init', function(event, slick){
			if($carousel.hasClass('js-equal-content')) {
				adjustHeight($carousel.find('.js-banner-carousel-content'));

				$( window ).resize(function() {
					adjustHeight($carousel.find('.js-banner-carousel-content'));
				});
			}
		});

	    $carousel .slick({
		    autoplay: true,
		    autoplaySpeed: 6000,
		    arrows: true,
		    dots: true,
		    infinite: true,
	    	fade: true,
	    	mobileFirst: true,
		    speed: 600,
	    });
    });

    if($('.js-banner-carousel-video').length) {
		var tag = document.createElement('script');
		tag.src = "//www.youtube.com/player_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	    $('.js-banner-carousel-video').each(function() {
	    	var $video = $(this),
	    		videoID = $video.attr('data-video');

	    	$video.append('<div id="video-' + videoID + '"></div>');

	        // NOTE: using set/clear interval due to race condition loading YouTube API
	        var interval = setInterval(function() {
	            if (isYouTubeApiLoaded()) {
			        new YT.Player('video-' + videoID, {
			        	videoId: videoID,
						playerVars: {
							'controls': 0,           
							'showinfo': 0,
							'rel': 0
						},
			            events: {
			                'onReady': function(e) {
			                	e.target.playVideo();
			                    e.target.mute();
			                },
			                'onStateChange': function(e) {
			                    if (e.data == YT.PlayerState.PLAYING) {
			                    	$video.find('iframe').css('opacity', '1');
						        }

			                    if (e.data === YT.PlayerState.ENDED) {
						            e.target.playVideo();
						        }
			                }
			            }
			        });
	                clearInterval(interval);
	            }
	        }, 100);
	    });
    }

    // Checks if 'YT' object exists (part of YouTube API)
    function isYouTubeApiLoaded() {
        if (window['YT'] && typeof window['YT'].Player === 'function') {
            return true;
        } else {
            return false;
        }
    }

    function adjustHeight($elements) {
    	var maxHeight = 0;

    	$elements.height('auto').each(function() {
    		var $element = $(this);

    		if($element.outerHeight() > maxHeight) {
    			maxHeight = $element.outerHeight();
    		}
    	});

    	$elements.height(maxHeight);
    }
}(jQuery));